module.exports = __webpack_public_path__ + "img/partner_1.2a5b824b.png";